<template>
    <div class="table-responsive">
        <table class="table-hover mb-0">
            <thead>
                <tr>
                    <th colspan="2">Precio de Venta</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th colspan="2" class="text-center">
                        <h3 class="mb-0">
                            $ DATA
                        </h3>
                    </th>
                </tr>
                <tr>
                    <td>
                        Presupuesto Cliente
                    </td>
                    <td>$ DATA</td>
                </tr>
                <tr>
                    <td colspan="2" class="text-center">
                        <strong>Forma de Pago</strong>
                    </td>
                </tr>
                <tr v-if="formaPagoData.efectivo">
                    <td><i class="fa fa-money"></i>&nbsp;Efectivo</td>
                    <td>$ DATA</td>
                </tr>
                <tr>
                    <td colspan="2">
                        <i class="fa fa-university"></i>&nbsp;Credito
                        <table class="table table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <td>
                                        <span class="span-td"
                                            >Llevalo sin cuota inicial</span
                                        ><br />
                                        <a href="javascript:void(0)"
                                        data-toggle="modal"
                                        data-target="#credito_propuesta"> Ver Simulación</a>
                                    </td>
                                    <td class="text-right">
                                        $ DATA
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr
                    
                >
                    <td colspan="2">
                        <i class="fa fa-car"></i>&nbsp;Usado <br />
                        <span class="span-td">
                            (Usado titulo)</span
                        >
                        <table class="table table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <td>
                                        <a 
                                        href="javascript:void(0)"
                                        data-toggle="modal"
                                        data-target="#cotizacion_propuesta"> Ver Cotización</a>  
                                    </td>
                                    <td class="text-right">
                                        $ DATA
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <!--<tr>
                    <td colspan="2" class="text-center">
                        <input
                            type="submit"
                            class="btn"
                            value="Confirmar Oferta"
                        />
                    </td>
                </tr>-->
            </tbody>
        </table>
        <cotizacionPropuestaModal />
        <creditoPropuestaModal />
    </div>
</template>

<script>
import mainHelper from "helpers/main-helper";
import cotizacionPropuestaModal from "components/leadModals/cotizacionPropuestaModal";
import creditoPropuestaModal from "components/leadModals/creditoPropuestaModal";
export default {
    components: {
        cotizacionPropuestaModal,
        creditoPropuestaModal
    },
    computed: {
        inventarioData() {
            return this.$store.state.propuesta.inventario;
        },
        basicoData() {
            return this.$store.state.propuesta.basico;
        },
        formaPagoData() {
            return this.$store.state.propuesta.forma_pago;
        },
        creditoData() {
            return this.$store.state.propuesta.credito_form;
        },
        usadoData() {
            return this.$store.state.propuesta.vehiculo_usado;
        }
    },
    methods: {
        formatPrice(number) {
            return mainHelper.numberWithDots(number);
        }
    }
};
</script>

<style lang="scss" scoped></style>
